import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M7.99996 4.9974V7.9974L9.99996 9.9974M14.3333 7.9974C14.3333 11.4952 11.4978 14.3307 7.99996 14.3307C4.50216 14.3307 1.66663 11.4952 1.66663 7.9974C1.66663 4.49959 4.50216 1.66406 7.99996 1.66406C11.4978 1.66406 14.3333 4.49959 14.3333 7.9974Z",
      stroke: "currentColor",
      "stroke-linecap": "square",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }